export default "__VITE_ASSET__41b5f7e2__"